import React from 'react'

const OtherTextField = ({
  field, // { name, value, onChange, onBlur }
  form: { errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

  type,
  ...props
}) => {
  //console.log('note: inner most')
  //console.log(errors)

  return <input type={type} {...field} {...props} />
}

export default React.memo(OtherTextField)
//form: { errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.
